import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./QuestionPage.css";
import dbzsAudio from "../assets/dbzs.mp3";

function QuestionPage() {
    const navigate = useNavigate();
    const [answer, setAnswer] = useState("");
    const [error, setError] = useState("");

    const CORRECT_ANSWER = "bcnpq";
    const QUESTION =
        "write down the first letter of name of the all 5 pokemons you found in alphabetical order. For exampple, if you found Bulbasaur, Charmander, Squirtle, Pikachu and Eevee, your answer should be: bceps";

    useEffect(() => {
        if (answer.toLowerCase().trim() === CORRECT_ANSWER.toLowerCase()) {
            // Stop any existing audio
            if (window.currentAudio) {
                window.currentAudio.pause();
                window.currentAudio.currentTime = 0;
            }
            // Start new audio with 100% volume
            const audio = new Audio(dbzsAudio);
            audio.volume = 1.0;
            audio.loop = true;
            audio.play().catch(error => console.log("Audio play failed:", error));
            // Store new audio reference
            window.currentAudio = audio;
            navigate("/gift");
        }
    }, [answer, navigate]);

    const handleBack = () => {
        navigate("/radar");
    };

    return (
        <div className="question-page">
            <button className="back-button" onClick={handleBack}>
                ← Back
            </button>
            <div className="question-container">
                <h1 className="question-title">Final Challenge!</h1>
                <div className="question-box">
                    <p className="question-text">{QUESTION}</p>
                    <input
                        type="text"
                        className="answer-input"
                        value={answer}
                        onChange={e => setAnswer(e.target.value)}
                        placeholder="Type your answer..."
                        autoFocus
                    />
                    {error && <p className="error-message">{error}</p>}
                </div>
            </div>
        </div>
    );
}

export default QuestionPage;
